import {
  selectPageElement,
  trackLumberjackAndSegment,
  isMobile
} from './segment-utils';
import {
  isElementXPercentInViewport,
  debounce,
  qs,
  getCookie
} from '../modules/util';
import { getCurrentPageSectionsMap } from './x-page-sections';
import lj from '../lumberjack';
import { getLjEventProps } from '../getLjEventProps';

let ljproperties = getLjEventProps();

selectPageElement('nav-demo-mode-entry-nomob') &&
  selectPageElement('nav-demo-mode-entry-nomob').addEventListener(
    'click',
    e => {
      trackLumberjackAndSegment(e, 'Demo_mode_entry_point_cta', 'top_nav_bar');
    }
  );

selectPageElement('nav-x-demo-mode-entry-nomob') &&
  selectPageElement('nav-x-demo-mode-entry-nomob').addEventListener(
    'click',
    e => {
      trackLumberjackAndSegment(e, 'Demo_mode_entry_point_cta', 'top_nav_bar');
    }
  );

selectPageElement('footer-demo-mode-entry-nomob') &&
  selectPageElement('footer-demo-mode-entry-nomob').addEventListener(
    'click',
    e => {
      trackLumberjackAndSegment(e, 'Demo_mode_entry_point_cta', 'footer');
    }
  );

selectPageElement('footer-x-demo-mode-entry-nomob') &&
  selectPageElement('footer-x-demo-mode-entry-nomob').addEventListener(
    'click',
    e => {
      trackLumberjackAndSegment(e, 'Demo_mode_entry_point_cta', 'footer');
    }
  );

selectPageElement('demo-mode-entry-point-cta') &&
  selectPageElement('demo-mode-entry-point-cta').addEventListener(
    'click',
    e => {
      trackLumberjackAndSegment(e, 'Demo_mode_entry_point_cta', 'CA_Demo_CTA');
    }
  );

selectPageElement('CS form closed clicked') &&
  selectPageElement('CS form closed clicked').addEventListener('click', e => {
    trackLumberjackAndSegment(e, 'CS_form_closed', 'contact sales');
  });

selectPageElement('CS Get in touch cta clicked mob') &&
  selectPageElement('CS Get in touch cta clicked mob').addEventListener(
    'click',
    e => {
      trackLumberjackAndSegment(e, 'CS_Get_in_touch_cta', 'pricing');
    }
  );

selectPageElement('CS Get in touch cta clicked nomob') &&
  selectPageElement('CS Get in touch cta clicked nomob').addEventListener(
    'click',
    e => {
      trackLumberjackAndSegment(e, 'CS_Get_in_touch_cta', 'pricing');
    }
  );

selectPageElement('ca eligible Sign Up Cta clicked') &&
  selectPageElement('ca eligible Sign Up Cta clicked').addEventListener(
    'click',
    e => {
      trackLumberjackAndSegment(e, 'Sign_Up_Cta', 'contact sales ca eligible');
    }
  );

selectPageElement('ca eligible CS ca demo cta clicked') &&
  selectPageElement('ca eligible CS ca demo cta clicked').addEventListener(
    'click',
    e => {
      trackLumberjackAndSegment(
        e,
        'CS_ca_demo_cta',
        'contact sales ca eligible'
      );
    }
  );

selectPageElement('ca not eligible Sign Up Cta clicked') &&
  selectPageElement('ca not eligible Sign Up Cta clicked').addEventListener(
    'click',
    e => {
      trackLumberjackAndSegment(
        e,
        'Sign_Up_Cta',
        'contact sales ca not eligible'
      );
    }
  );

selectPageElement('CS non-ca know more cta clicked') &&
  selectPageElement('CS non-ca know more cta clicked').addEventListener(
    'click',
    e => {
      trackLumberjackAndSegment(
        e,
        'CS_non-ca_know_more_cta',
        'contact sales ca not eligible'
      );
    }
  );

selectPageElement('CS pg login cta clicked') &&
  selectPageElement('CS pg login cta clicked').addEventListener('click', e => {
    trackLumberjackAndSegment(e, 'CS_pg_login_cta', 'contact sales pg');
  });

selectPageElement('CS refund cta clicked') &&
  selectPageElement('CS refund cta clicked').addEventListener('click', e => {
    trackLumberjackAndSegment(e, 'CS_refund_cta', 'contact sales refund');
  });

selectPageElement('X-Mobile-App Google_play_cta mob') &&
  selectPageElement('X-Mobile-App Google_play_cta mob').addEventListener(
    'click',
    e => {
      trackLumberjackAndSegment(e, 'Google_play_cta', 'Hero section');
    }
  );

selectPageElement('X-Mobile-App Apple_app_store_cta mob') &&
  selectPageElement('X-Mobile-App Apple_app_store_cta mob').addEventListener(
    'click',
    e => {
      trackLumberjackAndSegment(e, 'Apple_app_store_cta', 'Hero section');
    }
  );

selectPageElement('X-Mobile-App Google_play_cta web') &&
  selectPageElement('X-Mobile-App Google_play_cta web').addEventListener(
    'click',
    e => {
      trackLumberjackAndSegment(e, 'Google_play_cta', 'Hero section');
    }
  );

selectPageElement('X-Mobile-App Apple_app_store_cta web') &&
  selectPageElement('X-Mobile-App Apple_app_store_cta web').addEventListener(
    'click',
    e => {
      trackLumberjackAndSegment(e, 'Apple_app_store_cta', 'Hero section');
    }
  );

selectPageElement('CA page mobile_learn_more_cta web') &&
  selectPageElement('CA page mobile_learn_more_cta web').addEventListener(
    'click',
    e => {
      trackLumberjackAndSegment(e, 'mobile_learn_more_cta', 'Mobile app');
    }
  );

selectPageElement('CA page mobile_learn_more_cta mob') &&
  selectPageElement('CA page mobile_learn_more_cta mob').addEventListener(
    'click',
    e => {
      trackLumberjackAndSegment(e, 'mobile_learn_more_cta', 'Mobile app');
    }
  );

selectPageElement('Payouts page mobile_learn_more_cta web') &&
  selectPageElement('Payouts page mobile_learn_more_cta web').addEventListener(
    'click',
    e => {
      trackLumberjackAndSegment(e, 'mobile_learn_more_cta', 'Mobile app');
    }
  );

selectPageElement('Payouts page mobile_learn_more_cta mob') &&
  selectPageElement('Payouts page mobile_learn_more_cta mob').addEventListener(
    'click',
    e => {
      trackLumberjackAndSegment(e, 'mobile_learn_more_cta', 'Mobile app');
    }
  );

selectPageElement('X-Home page mobile_learn_more_cta web') &&
  selectPageElement('X-Home page mobile_learn_more_cta web').addEventListener(
    'click',
    e => {
      trackLumberjackAndSegment(e, 'mobile_learn_more_cta', 'Work efficiently');
    }
  );

selectPageElement('X-Home page mobile_learn_more_cta mob') &&
  selectPageElement('X-Home page mobile_learn_more_cta mob').addEventListener(
    'click',
    e => {
      trackLumberjackAndSegment(e, 'mobile_learn_more_cta', 'Work efficiently');
    }
  );

selectPageElement('X-Nav-Signup') &&
  selectPageElement('X-Nav-Signup').addEventListener('click', e => {
    trackLumberjackAndSegment(e, 'Sign_Up_Cta', 'Top nav bar');
  });

selectPageElement('X - Get Started Now') &&
  selectPageElement('X - Get Started Now').addEventListener('click', e => {
    trackLumberjackAndSegment(e, 'Sign_Up_Cta', 'Hero section');
  });

selectPageElement('X-Pricing-Basic Signup btn') &&
  selectPageElement('X-Pricing-Basic Signup btn').addEventListener(
    'click',
    e => {
      trackLumberjackAndSegment(e, 'Sign_Up_Cta', 'Pricing', {
        pricing_type: 'basic'
      });
    }
  );

selectPageElement('X-Pricing-Pro Signup btn') &&
  selectPageElement('X-Pricing-Pro Signup btn').addEventListener('click', e => {
    trackLumberjackAndSegment(e, 'Sign_Up_Cta', 'Pricing', {
      pricing_type: 'pro'
    });
  });

selectPageElement('X-Xperience Signup btn') &&
  selectPageElement('X-Xperience Signup btn').addEventListener('click', e => {
    trackLumberjackAndSegment(e, 'Sign_Up_Cta', 'Bottom section');
  });

selectPageElement('X-Current-Account Get Started Now') &&
  selectPageElement('X-Current-Account Get Started Now').addEventListener(
    'click',
    e => {
      $('.social-strip .container').attr(
        'data-x-ca-social-proof-strip-variant'
      ) === 'enabled'
        ? trackLumberjackAndSegment(e, 'Sign_Up_Cta', 'Hero section', {
            version: 'variation',
            page: 'CA',
            first_utm: ljproperties.firstUtm,
            last_utm: ljproperties.lastUtm
          })
        : trackLumberjackAndSegment(e, 'Sign_Up_Cta', 'Hero section', {
            version: 'control',
            page: 'CA',
            first_utm: ljproperties.firstUtm,
            last_utm: ljproperties.lastUtm
          });
    }
  );
selectPageElement('X-Current-Account apply-now-section Get Started Now') &&
  selectPageElement(
    'X-Current-Account apply-now-section Get Started Now'
  ).addEventListener('click', e => {
    trackLumberjackAndSegment(e, 'Sign_Up_Cta', 'CA features');
  });

selectPageElement('X-TDS-Online-Payment Signup btn') &&
  selectPageElement('X-TDS-Online-Payment Signup btn').addEventListener(
    'click',
    e => {
      trackLumberjackAndSegment(e, 'Sign_Up_Cta', 'Tax payments');
    }
  );

selectPageElement('X-Vendor-Payments Banner Signup btn') &&
  selectPageElement('X-Vendor-Payments Banner Signup btn').addEventListener(
    'click',
    e => {
      trackLumberjackAndSegment(e, 'Sign_Up_Cta', 'Hero section');
    }
  );

selectPageElement('X-Vendor-Payments automate-block Signup btn') &&
  selectPageElement(
    'X-Vendor-Payments automate-block Signup btn'
  ).addEventListener('click', e => {
    trackLumberjackAndSegment(e, 'Sign_up_cta', 'Top nav bar');
  });

selectPageElement('X-Vendor-Payments faqs-section Signup btn') &&
  selectPageElement(
    'X-Vendor-Payments faqs-section Signup btn'
  ).addEventListener('click', e => {
    trackLumberjackAndSegment(e, 'Sign_up_cta', 'Top nav bar');
  });

selectPageElement('X-Payouts banner Signup btn') &&
  selectPageElement('X-Payouts banner Signup btn').addEventListener(
    'click',
    e => {
      $('.supporting-text').attr('data-x-payouts-experiment-variant') ===
      'enabled'
        ? trackLumberjackAndSegment(e, 'Sign_Up_Cta', 'Hero section', {
            version: 'variation',
            page: 'payouts',
            first_utm: ljproperties.firstUtm,
            last_utm: ljproperties.lastUtm
          })
        : trackLumberjackAndSegment(e, 'Sign_Up_Cta', 'Hero section', {
            version: 'control',
            page: 'payouts',
            first_utm: ljproperties.firstUtm,
            last_utm: ljproperties.lastUtm
          });
    }
  );
selectPageElement('X-Payouts-Links banner Signup btn') &&
  selectPageElement('X-Payouts-Links banner Signup btn').addEventListener(
    'click',
    e => {
      trackLumberjackAndSegment(e, 'Sign_Up_Cta', 'Hero section');
    }
  );

selectPageElement('X-Payouts-Links pricing-basic Signup btn') &&
  selectPageElement(
    'X-Payouts-Links pricing-basic Signup btn'
  ).addEventListener('click', e => {
    trackLumberjackAndSegment(e, 'Sign_Up_Cta', 'Pricing', {
      pricing_type: 'basic'
    });
  });

selectPageElement('X-Payouts-Links pricing-pro Signup btn') &&
  selectPageElement('X-Payouts-Links pricing-pro Signup btn').addEventListener(
    'click',
    e => {
      trackLumberjackAndSegment(e, 'Sign_Up_Cta', 'Pricing', {
        pricing_type: 'pro'
      });
    }
  );

selectPageElement('X-Tax-Payments Get Started Now') &&
  selectPageElement('X-Tax-Payments Get Started Now').addEventListener(
    'click',
    e => {
      trackLumberjackAndSegment(e, 'Sign_Up_Cta', 'Hero section');
    }
  );

selectPageElement('X-Tax-Payments steps-section Get Started Now') &&
  selectPageElement(
    'X-Tax-Payments steps-section Get Started Now'
  ).addEventListener('click', e => {
    trackLumberjackAndSegment(e, 'Sign_Up_Cta', 'Steps to get started');
  });

selectPageElement('X-Accounting-Payouts Xperience Signup btn') &&
  selectPageElement(
    'X-Accounting-Payouts Xperience Signup btn'
  ).addEventListener('click', e => {
    trackLumberjackAndSegment(e, 'Sign_Up_Cta', 'Bottom section');
  });

selectPageElement('X-Accounting-Payouts-Quickbooks Signup btn') &&
  selectPageElement(
    'X-Accounting-Payouts-Quickbooks Signup btn'
  ).addEventListener('click', e => {
    trackLumberjackAndSegment(e, 'Sign_Up_Cta', 'Hero section');
  });

selectPageElement('X-Home FAQs Q1') &&
  selectPageElement('X-Home FAQs Q1').addEventListener('click', e => {
    trackLumberjackAndSegment(e, 'FAQ_Q1_cta', 'FAQ');
  });

selectPageElement('X-Home FAQs Q2') &&
  selectPageElement('X-Home FAQs Q2').addEventListener('click', e => {
    trackLumberjackAndSegment(e, 'FAQ_Q2_cta', 'FAQ');
  });

selectPageElement('X-Home FAQs Q3') &&
  selectPageElement('X-Home FAQs Q3').addEventListener('click', e => {
    trackLumberjackAndSegment(e, 'FAQ_Q3_cta', 'FAQ');
  });

selectPageElement('X-Home FAQs Q4') &&
  selectPageElement('X-Home FAQs Q4').addEventListener('click', e => {
    trackLumberjackAndSegment(e, 'FAQ_Q4_cta', 'FAQ');
  });

selectPageElement('X-Home FAQs Q5') &&
  selectPageElement('X-Home FAQs Q5').addEventListener('click', e => {
    trackLumberjackAndSegment(e, 'FAQ_Q5_cta', 'FAQ');
  });

selectPageElement('X-Home FAQs Q6') &&
  selectPageElement('X-Home FAQs Q6').addEventListener('click', e => {
    trackLumberjackAndSegment(e, 'FAQ_Q6_cta', 'FAQ');
  });

selectPageElement('X-Current-Account Accounting-Integration-cta') &&
  selectPageElement(
    'X-Current-Account Accounting-Integration-cta'
  ).addEventListener('click', e => {
    trackLumberjackAndSegment(
      e,
      'Accounting_integrations_cta',
      'Seamless integrations'
    );
  });

selectPageElement('X-Current-Account Vendor-Payments-cta') &&
  selectPageElement('X-Current-Account Vendor-Payments-cta').addEventListener(
    'click',
    e => {
      trackLumberjackAndSegment(e, 'vendor_payments_cta', 'Paying taxes');
    }
  );

selectPageElement('X-Current-Account Tax-Payments-cta') &&
  selectPageElement('X-Current-Account Tax-Payments-cta').addEventListener(
    'click',
    e => {
      trackLumberjackAndSegment(e, 'Tax_payments_cta', 'Paying taxes');
    }
  );

selectPageElement('X-Current-Account Secure-Access-cta') &&
  selectPageElement('X-Current-Account Secure-Access-cta').addEventListener(
    'click',
    e => {
      trackLumberjackAndSegment(e, 'Secure_Access_cta', 'Secure banking');
    }
  );

selectPageElement('X-Current-Account Payment-Security-cta') &&
  selectPageElement('X-Current-Account Payment-Security-cta').addEventListener(
    'click',
    e => {
      trackLumberjackAndSegment(e, 'Payment_Security_cta', 'Secure banking');
    }
  );

selectPageElement('X-Current-Account Account-Stability-cta') &&
  selectPageElement('X-Current-Account Account-Stability-cta').addEventListener(
    'click',
    e => {
      trackLumberjackAndSegment(e, 'Account_Stability_cta', 'Secure banking');
    }
  );

selectPageElement('X-Home Demo-video cta') &&
  selectPageElement('X-Home Demo-video cta').addEventListener('click', e => {
    trackLumberjackAndSegment(e, 'Demo_video_cta', 'Hero Section');
  });

selectPageElement('X-Home View-Demo cta') &&
  selectPageElement('X-Home View-Demo cta').addEventListener('click', e => {
    trackLumberjackAndSegment(e, 'Demo_mode_entry_point_cta', 'hero_fold');
  });

selectPageElement('X-Home Ecosystem Current-account') &&
  selectPageElement('X-Home Ecosystem Current-account').addEventListener(
    'click',
    e => {
      trackLumberjackAndSegment(e, 'Current_account_cta', 'Ecosystem diagram');
    }
  );

selectPageElement('X-Home Ecosystem Payment-gateway') &&
  selectPageElement('X-Home Ecosystem Payment-gateway').addEventListener(
    'click',
    e => {
      trackLumberjackAndSegment(
        e,
        'Razorpay_Payment_Gateway_cta',
        'Ecosystem diagram'
      );
    }
  );

selectPageElement('X-Home Ecosystem Corporate-card') &&
  selectPageElement('X-Home Ecosystem Corporate-card').addEventListener(
    'click',
    e => {
      trackLumberjackAndSegment(e, 'Corporate_card_cta', 'Ecosystem diagram');
    }
  );

selectPageElement('X-Home Ecosystem Instant-loans') &&
  selectPageElement('X-Home Ecosystem Instant-loans').addEventListener(
    'click',
    e => {
      trackLumberjackAndSegment(e, 'Instant_loans_cta', 'Ecosystem diagram');
    }
  );

selectPageElement('X-Home Ecosystem Standard-and-bulk-payouts') &&
  selectPageElement(
    'X-Home Ecosystem Standard-and-bulk-payouts'
  ).addEventListener('click', e => {
    trackLumberjackAndSegment(
      e,
      'Standard_and_bulk_payout_cta',
      'Ecosystem diagram'
    );
  });

selectPageElement('X-Home Ecosystem Payout-links') &&
  selectPageElement('X-Home Ecosystem Payout-links').addEventListener(
    'click',
    e => {
      trackLumberjackAndSegment(e, 'Payout_links_cta', 'Ecosystem diagram');
    }
  );

selectPageElement('X-Home Ecosystem Vendor-Payments') &&
  selectPageElement('X-Home Ecosystem Vendor-Payments').addEventListener(
    'click',
    e => {
      trackLumberjackAndSegment(e, 'Vendor_Payments_cta', 'Ecosystem diagram');
    }
  );

selectPageElement('X-Home Ecosystem Payroll-and-Insurance') &&
  selectPageElement('X-Home Ecosystem Payroll-and-Insurance').addEventListener(
    'click',
    e => {
      trackLumberjackAndSegment(
        e,
        'Payroll_and_Insurance_cta',
        'Ecosystem diagram'
      );
    }
  );

selectPageElement('X-Home Ecosystem tax-payments') &&
  selectPageElement('X-Home Ecosystem tax-payments').addEventListener(
    'click',
    e => {
      trackLumberjackAndSegment(e, 'Tax_payments_cta', 'Ecosystem diagram');
    }
  );

selectPageElement('X-Home Save time & cost vendor-payments') &&
  selectPageElement('X-Home Save time & cost vendor-payments').addEventListener(
    'click',
    e => {
      trackLumberjackAndSegment(e, 'Vendor_Payments_cta', 'Save time & cost');
    }
  );

selectPageElement('X-Home Save time & cost payroll') &&
  selectPageElement('X-Home Save time & cost payroll').addEventListener(
    'click',
    e => {
      trackLumberjackAndSegment(e, 'Payroll_cta', 'Save time & cost');
    }
  );

selectPageElement('X-Home Scale Easily bulk payouts') &&
  selectPageElement('X-Home Scale Easily bulk payouts').addEventListener(
    'click',
    e => {
      trackLumberjackAndSegment(e, 'Bulk_Payouts_cta', 'Scale Easily ');
    }
  );

selectPageElement('X-Home Gain control & visibility Accounting integrations') &&
  selectPageElement(
    'X-Home Gain control & visibility Accounting integrations'
  ).addEventListener('click', e => {
    trackLumberjackAndSegment(
      e,
      'Accounting_integrations_cta',
      'Gain control & visibility'
    );
  });

selectPageElement('X-Home Manage cash flows RazorpayX corporate credit') &&
  selectPageElement(
    'X-Home Manage cash flows RazorpayX corporate credit'
  ).addEventListener('click', e => {
    trackLumberjackAndSegment(
      e,
      'RazorpayX_corporate_credit_card_cta',
      'Manage cash flows'
    );
  });

selectPageElement('X Integrations tally-cta') &&
  selectPageElement('X Integrations tally-cta').addEventListener('click', e => {
    trackLumberjackAndSegment(e, 'Tally_cta', 'Integrations');
  });

selectPageElement('X Integrations quickBooks-cta') &&
  selectPageElement('X Integrations quickBooks-cta').addEventListener(
    'click',
    e => {
      trackLumberjackAndSegment(e, 'QuickBooks_cta', 'Integrations');
    }
  );
//getting clicked at a final event
selectPageElement('X Integrations ZohoBooks-cta') &&
  selectPageElement('X Integrations ZohoBooks-cta').addEventListener(
    'mouseover',
    e => {
      trackLumberjackAndSegment(e, 'Zoho_Books_cta', 'Integrations');
    }
  );

selectPageElement('Pricing X basic view more') &&
  selectPageElement('Pricing X basic view more').addEventListener(
    'click',
    e => {
      trackLumberjackAndSegment(e, 'RazorpayX_Basic_view_more_cta', 'Pricing');
    }
  );

selectPageElement('Pricing X pro view more') &&
  selectPageElement('Pricing X pro view more').addEventListener('click', e => {
    trackLumberjackAndSegment(e, 'RazorpayX_Pro_view_more_cta', 'Pricing');
  });

selectPageElement('Payouts Page Automate payouts view Api Integrations') &&
  selectPageElement(
    'Payouts Page Automate payouts view Api Integrations'
  ).addEventListener('click', e => {
    trackLumberjackAndSegment(
      e,
      'View_API_documentation_cta',
      'Automate payouts'
    );
  });

selectPageElement('Payouts Page Banner section View Demo CTA') &&
  selectPageElement(
    'Payouts Page Banner section View Demo CTA'
  ).addEventListener('click', e => {
    trackLumberjackAndSegment(e, 'Demo_mode_entry_point_cta', 'hero_section');
  });

selectPageElement('Payouts Page Demo Preview GIF') &&
  selectPageElement('Payouts Page Demo Preview GIF').addEventListener(
    'click',
    e => {
      trackLumberjackAndSegment(e, 'Demo_mode_entry_point_cta', 'Demo_Gif');
    }
  );

selectPageElement('Payouts Page Demo Preview CTA') &&
  selectPageElement('Payouts Page Demo Preview CTA').addEventListener(
    'click',
    e => {
      trackLumberjackAndSegment(e, 'Demo_mode_entry_point_cta', 'Demo_CTA');
    }
  );

selectPageElement('Payouts Page mweb Demo Preview CTA') &&
  selectPageElement('Payouts Page mweb Demo Preview CTA').addEventListener(
    'click',
    e => {
      trackLumberjackAndSegment(e, 'Sign_Up_Cta', 'payouts_mweb_demo');
    }
  );

selectPageElement(
  'Payouts Page Accounting integrations view Accounting integrations'
) &&
  selectPageElement(
    'Payouts Page Accounting integrations view Accounting integrations'
  ).addEventListener('click', e => {
    trackLumberjackAndSegment(
      e,
      'Accounting_integrations_cta',
      'Accounting integrations'
    );
  });

selectPageElement('TaxPayments Hero properties Try free tool') &&
  selectPageElement(
    'TaxPayments Hero properties Try free tool'
  ).addEventListener('click', e => {
    trackLumberjackAndSegment(e, 'Try_free_tool_cta', 'Hero section');
  });

selectPageElement('TaxPayments Hero properties play video') &&
  selectPageElement('TaxPayments Hero properties play video').addEventListener(
    'click',
    e => {
      trackLumberjackAndSegment(e, 'Tax_payments_video_cta', 'Hero section');
    }
  );

selectPageElement(
  'TaxPayments Page Accounting integrations vendor payments cta'
) &&
  selectPageElement(
    'TaxPayments Page Accounting integrations vendor payments cta'
  ).addEventListener('click', e => {
    trackLumberjackAndSegment(
      e,
      'vendor_payments_cta',
      'Accounting integrations'
    );
  });

selectPageElement(
  'TaxPayments Page Accounting integrations api based payouts cta'
) &&
  selectPageElement(
    'TaxPayments Page Accounting integrations api based payouts cta'
  ).addEventListener('click', e => {
    trackLumberjackAndSegment(
      e,
      'api_based_payouts_cta',
      'Accounting integrations'
    );
  });

selectPageElement('Accounting-Payouts Tally-Payouts Get-early-access-cta') &&
  selectPageElement(
    'Accounting-Payouts Tally-Payouts Get-early-access-cta'
  ).addEventListener('click', e => {
    trackLumberjackAndSegment(e, 'Get_early_access_cta', 'Hero section');
    addEarlyAccessModalEvents();
  });

selectPageElement(
  'X Vendor-Payments Email-Integration Top-nav-bar Sign-Up-Cta-clicked'
) &&
  selectPageElement(
    'X Vendor-Payments Email-Integration Top-nav-bar Sign-Up-Cta-clicked'
  ).addEventListener('click', e => {
    trackLumberjackAndSegment(e, 'Sign Up Cta', 'Top nav bar');
  });

selectPageElement(
  'X Vendor-Payments Email-Integration Hero-section Sign-Up-Cta-clicked'
) &&
  selectPageElement(
    'X Vendor-Payments Email-Integration Hero-section Sign-Up-Cta-clicked'
  ).addEventListener('click', e => {
    trackLumberjackAndSegment(e, 'Sign Up Cta', 'Hero Section');
  });

selectPageElement(
  'X Vendor-Payments Email-Integration Get-started-card Sign-Up-Cta-clicked'
) &&
  selectPageElement(
    'X Vendor-Payments Email-Integration Get-started-card Sign-Up-Cta-clicked'
  ).addEventListener('click', e => {
    trackLumberjackAndSegment(e, 'Sign Up Cta', 'Get started card');
  });

selectPageElement('neobank-navbar-nomob') &&
  selectPageElement('neobank-navbar-nomob').addEventListener('click', e => {
    trackLumberjackAndSegment(e, 'Download report CTA', 'Sticky banner');
  });

selectPageElement('neobank-navbar-mob') &&
  selectPageElement('neobank-navbar-mob').addEventListener('click', e => {
    trackLumberjackAndSegment(e, 'Download report CTA', 'Sticky banner');
  });

selectPageElement('neobank-banner-report') &&
  selectPageElement('neobank-banner-report').addEventListener('click', e => {
    trackLumberjackAndSegment(e, 'Download report CTA', 'Hero fold');
  });

selectPageElement('neobank-features-report') &&
  selectPageElement('neobank-features-report').addEventListener('click', e => {
    trackLumberjackAndSegment(e, 'Download report CTA', 'Six points fold');
  });

selectPageElement('neobank-revolution-report-nomob') &&
  selectPageElement('neobank-revolution-report-nomob').addEventListener(
    'click',
    e => {
      trackLumberjackAndSegment(e, 'Download report CTA', 'Indias report fold');
    }
  );

selectPageElement('neobank-revolution-report-mob') &&
  selectPageElement('neobank-revolution-report-mob').addEventListener(
    'click',
    e => {
      trackLumberjackAndSegment(e, 'Download report CTA', 'Indias report fold');
    }
  );

selectPageElement('neobank-footer-signup') &&
  selectPageElement('neobank-footer-signup').addEventListener('click', e => {
    trackLumberjackAndSegment(e, 'Sign Up Cta', 'Last fold');
  });

selectPageElement('razorpay-x-neobank-report-modal') &&
  selectPageElement('razorpay-x-neobank-report-modal').addEventListener(
    'mouseover',
    e => {
      trackLumberjackAndSegment(e, 'Lead form');
    },
    { once: true }
  );

selectPageElement('razorpay-x-neobank-report-modal-close') &&
  selectPageElement('razorpay-x-neobank-report-modal-close').addEventListener(
    'click',
    e => {
      trackLumberjackAndSegment(e, 'Lead form closed');
    }
  );

selectPageElement('razorpay-x-neobank-report-modal-submit') &&
  selectPageElement('razorpay-x-neobank-report-modal-submit').addEventListener(
    'click',
    e => {
      const enteredName =
        document.forms['neobank-report-lead-form']['name'].value;
      const enteredEmail =
        document.forms['neobank-report-lead-form']['email'].value;
      const enteredPhone = `+91${document.forms['neobank-report-lead-form']['phone'].value}`;
      const enteredDesignation =
        document.forms['neobank-report-lead-form']['designation'].value;
      const userIdentity = window.analytics._user.id() || getCookie('clientId');
      window.analytics.identify(userIdentity, {
        subscriptionStatus: 'inactive',
        campaign: 'Neobank Report Lead Form',
        name: enteredName,
        email: enteredEmail,
        phone: enteredPhone,
        designation: enteredDesignation,
        anonymousId: localStorage.getItem('ajs_anonymous_id'),
        device_type: isMobile() ? 'mweb' : 'dweb',
        clientId: getCookie('clientId')
      });
      trackLumberjackAndSegment(
        e,
        'Lead form submit',
        '',
        {
          name: enteredName,
          email: enteredEmail,
          phone: enteredPhone,
          designation: enteredDesignation
        },
        true
      );
    }
  );

function addEarlyAccessModalEvents() {
  selectPageElement('Accounting-Payouts Tally-Payouts Full-name-entered') &&
    selectPageElement(
      'Accounting-Payouts Tally-Payouts Full-name-entered'
    ).addEventListener('change', e => {
      trackLumberjackAndSegment(
        e,
        'Full_name_entered',
        'Accounting payouts - early access'
      );
    });

  selectPageElement('Accounting-Payouts Tally-Payouts Email-entered') &&
    selectPageElement(
      'Accounting-Payouts Tally-Payouts Email-entered'
    ).addEventListener('change', e => {
      trackLumberjackAndSegment(
        e,
        'Email_ID_entered',
        'Accounting payouts - early access'
      );
    });

  selectPageElement('Accounting-Payouts Tally-Payouts Mobile-entered') &&
    selectPageElement(
      'Accounting-Payouts Tally-Payouts Mobile-entered'
    ).addEventListener('change', e => {
      trackLumberjackAndSegment(
        e,
        'Mobile_number_entered',
        'Accounting payouts - early access'
      );
    });

  selectPageElement('Accounting-Payouts Tally-Payouts Early-access-submit') &&
    selectPageElement(
      'Accounting-Payouts Tally-Payouts Early-access-submit'
    ).addEventListener('click', e => {
      trackLumberjackAndSegment(
        e,
        'Submit_cta',
        'Accounting payouts - early access'
      );
    });
}

const pageSectionsMap = getCurrentPageSectionsMap();

$(function() {
  if (!!pageSectionsMap) {
    window.addEventListener(
      'scroll',
      debounce(evaluateSectionViewedEvents, 200)
    );
  }
});

function evaluateSectionViewedEvents() {
  Object.keys(pageSectionsMap).forEach(pageSectionName => {
    const pageSectionSelector = pageSectionsMap[pageSectionName]['selector'];
    const isPageSectionImpressionRecorded =
      pageSectionsMap[pageSectionName]['isImpressionRecorded'];
    const selectedSectionElement = qs(pageSectionSelector);

    if (
      !!selectedSectionElement &&
      !isPageSectionImpressionRecorded &&
      isElementXPercentInViewport(selectedSectionElement, 65)
    ) {
      let properties = Object.assign({
        anonymousId: localStorage.getItem('ajs_anonymous_id'),
        url: location.href,
        section: pageSectionName
      });
      lj.pushEvents({
        event_name: 'Section',
        event_type: 'viewed',
        properties: properties
      });
      pageSectionsMap[pageSectionName]['isImpressionRecorded'] = true;
    }
  });
}
